module.exports = __webpack_public_path__ + "static/media/TM.84b5e397.png";